import React from 'react';
import { useTranslation } from 'react-i18next';
import { ShieldCheck, TrendingUp, Building2, ArrowRight, CheckCircle2 } from 'lucide-react';

const SupplierLanding = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-[#F8FAFC] font-sans text-slate-900 selection:bg-blue-100">
      
      <section className="relative px-6 py-24 mx-auto max-w-7xl md:py-32 overflow-hidden">
        <div className="relative z-10 text-center max-w-4xl mx-auto">
          <div className="inline-flex items-center gap-2 px-4 py-2 mb-8 text-sm font-semibold text-blue-700 bg-blue-50 border border-blue-100 rounded-full shadow-sm">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-blue-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-blue-600"></span>
            </span>
            {t('supplierLanding.pillLive')}
          </div>
          <h1 className="text-5xl font-extrabold tracking-tight text-slate-900 sm:text-6xl md:text-7xl">
            {t('supplierLanding.heroTitlePart1')} <span className="text-blue-600">{t('supplierLanding.heroTitleHighlight')}</span>
          </h1>
          <p className="max-w-2xl mx-auto mt-6 text-xl text-slate-600 leading-relaxed">
            {t('supplierLanding.heroSub')}
          </p>
          <div className="flex flex-col sm:flex-row justify-center mt-10 gap-4">
            <a href="/register" className="inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-white transition-all bg-blue-600 rounded-lg hover:bg-blue-700 hover:shadow-lg hover:shadow-blue-600/20 group">
              {t('supplierLanding.ctaPrimary')}
              <ArrowRight className="w-5 h-5 ml-2 transition-transform group-hover:translate-x-1" />
            </a>
            <p className="mt-4 text-sm text-slate-500 sm:mt-0 sm:self-center font-medium">
              {t('supplierLanding.ctaSub')}
            </p>
          </div>
        </div>
      </section>

      <section className="py-24 bg-white border-y border-slate-200">
        <div className="px-6 mx-auto max-w-7xl">
          <div className="mb-16 text-center">
            <h2 className="text-3xl font-bold text-slate-900 md:text-4xl">{t('supplierLanding.sectionTitle')}</h2>
          </div>
          <div className="grid grid-cols-1 gap-8 md:grid-cols-3">
            <div className="p-8 transition-shadow bg-[#F8FAFC] border border-slate-200 rounded-2xl hover:border-blue-200">
              <div className="flex items-center justify-center w-14 h-14 mb-6 bg-blue-100 rounded-xl"><TrendingUp className="w-7 h-7 text-blue-600" /></div>
              <h3 className="mb-3 text-xl font-bold text-slate-900">{t('supplierLanding.feat1Title')}</h3>
              <p className="text-slate-600 leading-relaxed">{t('supplierLanding.feat1Desc')}</p>
            </div>
            <div className="p-8 transition-shadow bg-[#F8FAFC] border border-slate-200 rounded-2xl hover:border-blue-200">
              <div className="flex items-center justify-center w-14 h-14 mb-6 bg-blue-100 rounded-xl"><Building2 className="w-7 h-7 text-blue-600" /></div>
              <h3 className="mb-3 text-xl font-bold text-slate-900">{t('supplierLanding.feat2Title')}</h3>
              <p className="text-slate-600 leading-relaxed">{t('supplierLanding.feat2Desc')}</p>
            </div>
            <div className="p-8 transition-shadow bg-[#F8FAFC] border border-slate-200 rounded-2xl hover:border-blue-200">
              <div className="flex items-center justify-center w-14 h-14 mb-6 bg-blue-100 rounded-xl"><ShieldCheck className="w-7 h-7 text-blue-600" /></div>
              <h3 className="mb-3 text-xl font-bold text-slate-900">{t('supplierLanding.feat3Title')}</h3>
              <p className="text-slate-600 leading-relaxed">{t('supplierLanding.feat3Desc')}</p>
            </div>
          </div>
        </div>
      </section>

      <section className="px-6 py-24 mx-auto max-w-5xl">
        <div className="p-12 text-center bg-slate-900 rounded-3xl sm:p-16 relative overflow-hidden">
          <div className="absolute top-0 right-0 -mr-20 -mt-20 w-64 h-64 bg-blue-500 rounded-full blur-3xl opacity-20"></div>
          <h2 className="relative z-10 mb-6 text-3xl font-bold text-white md:text-4xl">{t('supplierLanding.closeTitle')}</h2>
          <ul className="relative z-10 flex flex-col sm:flex-row justify-center gap-6 mb-10 text-slate-300 font-medium">
            <li className="flex items-center justify-center gap-2"><CheckCircle2 className="w-5 h-5 text-blue-400"/> {t('supplierLanding.closeTick1')}</li>
            <li className="flex items-center justify-center gap-2"><CheckCircle2 className="w-5 h-5 text-blue-400"/> {t('supplierLanding.closeTick2')}</li>
            <li className="flex items-center justify-center gap-2"><CheckCircle2 className="w-5 h-5 text-blue-400"/> {t('supplierLanding.closeTick3')}</li>
          </ul>
          <a href="/register" className="relative z-10 inline-flex items-center justify-center px-8 py-4 text-lg font-bold text-slate-900 transition-all bg-white rounded-lg hover:bg-slate-100">
            {t('supplierLanding.closeCta')}
          </a>
        </div>
      </section>
    </div>
  );
};

export default SupplierLanding;